import { Component, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import { ExpedienteDet } from 'src/app/models/ExpedienteDet';
import { TipoDocExp } from 'src/app/models/TipoDocExp';
import { TipoDocExpService } from 'src/app/services/tipo-doc-exp.service';
import { Anho } from 'src/app/models/Anho';
import { AnhoService } from 'src/app/services/Anho.service';
import { Prioridad } from 'src/app/models/Prioridad';
import { PrioridadService } from 'src/app/services/prioridad.service';
import { SedeCgr } from 'src/app/models/SedeCgr';
import { SedeCgrService } from 'src/app/services/sede-cgr.service';
import { PersonalCgr } from 'src/app/models/PersonalCgr';
import { PersonalCgrService } from 'src/app/services/personal-cgr.service';
import { MfuncErrorVal, openModalMensaje, CodTipoExpDetREF, CodTipoExpDetDES, CodTipoFichaEXP, GlobalVars,  RecupPartesFchInicio,  ConvertDateTimeToStr, ConvertStrDateToFormatBD, RecupPartesDocExp, CodUnoGestDenuncias, CodUnoSubGerCMP, isNotEmpty, NumIdTipCatTipRemitente, NumIdCatTROtros, ConvertDateTimeToStr2, GetDateTimeString, isEmpty, NumIdCatTRCiudadano, NumIdCatTRPJ, NumIdTipDenPersNat, NumIdTipDocPersJur, iconBuscar, gvCanal, RecupObjDatosPlant, GetDateTime, CodSubTipoFichaOFI, CodTipoFichaFUR, DscNombreFileOficioFUR, saveContent2, iconDescargar } from 'src/app/general/variables';
import { ErrorValidator } from 'src/app/models/personalizados/ErrorValidator';
import { FurService } from 'src/app/services/fur.service';
import { Fur } from 'src/app/models/Fur';
import { MatDialog } from '@angular/material/dialog';
import { BodyDatosGeneralComponent } from '../body-datos-general/body-datos-general.component';
import { Observable } from 'rxjs/internal/Observable';
import { Catalogo } from 'src/app/models/Catalogo';
import { Persona } from 'src/app/models/Persona';
import { CatalogoService } from 'src/app/services/Catalogo.service';
import { General } from 'src/app/models/General';
import { Entidad } from 'src/app/models/Entidad';
import { FechaHoraMaterialComponent } from '../../General/fecha-hora-material/fecha-hora-material.component';
import { EvidenciasComponent } from '../../denuncia/evidencias/evidencias.component';
import { TipoDocumentoService } from 'src/app/services/tipo-documento.service';
import { TipoDocumento } from 'src/app/models/TipoDocumento';
import { ExternosService } from 'src/app/services/externos/externos.service';
import { UniOrganicaService } from 'src/app/services/uni-organica.service';
import { UniOrganica } from 'src/app/models/UniOrganica';
import { BusqEntidadComponent } from '../../general/busq-entidad/busq-entidad.component';
import { ParametroPlantillaDocumento, RecupUrlOficio, FiltrarListExpedienteDest, FiltrarListExpedienteRef, RecuperarGrillasPD } from 'src/app/general/Funciones';
import { PlantillaDocumento } from 'src/app/models/PlantillaDocumento';
import { DocumentoDet } from 'src/app/models/DocumentoDet';
// import { DatePipe } from '@angular/common';
// import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-body-datos-expediente',
  templateUrl: './body-datos-expediente.component.html',
  styleUrls: ['./body-datos-expediente.component.css']
})
export class BodyDatosExpedienteComponent implements OnInit {

  // strCodUno:string = "";
  // strDscFirmado:string = "";
  // strDscElaborado:string = "";
  // codPersFirmado:string = "";
  // codPersElaborado:string = "";
  // numIdTipoDoc:number = null;
  // strNroDoc1:string = "";
  // strNroDoc2:string = GetAnho().toString();
  // strNroDoc3:string = TipoNroExpdiente;
  // strDscAsunto:string = "";
  isEmpty = isEmpty;
  listaExpRef: ExpedienteDet[] = [];
  listaExpDest: ExpedienteDet[] = [];
  listTipRemitente: Catalogo[] = [];
  listTipoDocExp: TipoDocExp[] = [];
  listAnho: Anho[] = [];
  listPrioridad: Prioridad[] = [];
  listSedeCgr: SedeCgr[] = [];
  listPersonalCgr: PersonalCgr[] = [];
  iconDescargar = iconDescargar;

  flgDeshabilitado = true; // siempre true
  flgSoloLectura = false;
  flgRegistrar = true;
  general: General = new General();
  listTipoDocumento: TipoDocumento[] = [];
  listUniOrganica: UniOrganica[] = [];
  iconBuscar = iconBuscar;
  generalPD: General = new General();
  strDscUrlOfi = '';

  fur: Fur;

  @Output() opGuardadoOk = new EventEmitter();

  @ViewChild(BodyDatosGeneralComponent) bodyDatosGeneralC: BodyDatosGeneralComponent;
  @ViewChild(FechaHoraMaterialComponent) fechaHoraMaterialC: FechaHoraMaterialComponent;
  @ViewChild(EvidenciasComponent) evidenciasC: EvidenciasComponent;
  @ViewChild(BusqEntidadComponent) busqEntidadComponent: BusqEntidadComponent;


  errorValidator: ErrorValidator[] = [];
  mFuncErrorVal: MfuncErrorVal = new MfuncErrorVal();

  constructor(protected catalogoService: CatalogoService,
              protected tipoDocExpService: TipoDocExpService,
              protected anhoService: AnhoService,
              protected prioridadService: PrioridadService,
              protected sedeCgrService: SedeCgrService,
              protected personalCgrService: PersonalCgrService,
              protected furService: FurService,
              public dialog: MatDialog,
              protected tipoDocumentoService: TipoDocumentoService,
              protected uniOrganicaService: UniOrganicaService,
              protected parametroPlantillaDocumento: ParametroPlantillaDocumento,
              protected externosService: ExternosService) {

      this._initVariables();

    }

  ngOnInit() {

    this.uniOrganicaService.ListarUnidadOrganicaActiva().subscribe(data => {

      this.listUniOrganica = data;

    });

    this.catalogoService.listarCatalogo(NumIdTipCatTipRemitente).subscribe(data => {

      this.listTipRemitente = data;

    });

    this.tipoDocExpService.ListarTipoDocumentoExpediente().subscribe(data => {

      this.listTipoDocExp = data;

    });

    this.anhoService.listarAnho().subscribe(data => {

      this.listAnho = data;

    });



    this.tipoDocumentoService.obtenerTipoDocumento().subscribe(
      data => {
        this.listTipoDocumento = data;

      }
    );

    this.evidenciasC.setEvidenciaTitulo('Lista de archivos Adjuntos');
    this.evidenciasC.setStrDscColEtiq1('Descripción');

    this.fur.cfurIdusureg = GlobalVars.CodPersonal;

    this.parametroPlantillaDocumento.recupParamPlantillaDoc(13).subscribe(data => {

      this.generalPD = data;

    });

  }

  _generarPlantilla(numIdFur: number, flgProcLF?: boolean) {

    // var vListGeneralFinal:General[] = [];
    const vPlantillaDocumento: PlantillaDocumento = new PlantillaDocumento();
    const vListDocumentoDet: DocumentoDet[] = [];
    let vFur: Fur = null;
    const vGeneralReturn: General = new General();

    flgProcLF = (flgProcLF == null ? true : false);

    vPlantillaDocumento.datos = [];
    // vPlantillaDocumento.tabla = [];

    const plantillaObservable = new Observable<General>(observer => {

      // OBTENGO LOS ULTIMOS DATOS

      this.furService.ObtenerPlantillaFurPorId(numIdFur).subscribe(
        data => {

          vFur = data;

          this.generalPD.listaPdDatos = RecupObjDatosPlant(vFur, this.generalPD.listaPdDatos);

          vPlantillaDocumento.nombreArchivoPlantilla = this.generalPD.dscCampo1;
          vPlantillaDocumento.nombreArchivoGenerado = this.generalPD.dscCampo2;
          vPlantillaDocumento.datos = this.generalPD.listaPdDatos;

          vPlantillaDocumento.grillas = RecuperarGrillasPD('5', vFur.listaExpedienteDet, 2);

          vPlantillaDocumento.grillas = RecuperarGrillasPD('7', vFur.listaExpedienteDet, 3, vPlantillaDocumento.grillas);

          vPlantillaDocumento.grillas = RecuperarGrillasPD('9', vFur.listaDocumentoAdjuntoDet, 1, vPlantillaDocumento.grillas);

          // vPlantillaDocumento.grillas = GenerarListGrillaEvidencia("4",vFur.listaDocumentoAdjuntoDet);



          console.log('===============vPlantillaDocumento');
          console.log(JSON.stringify(vPlantillaDocumento));

          this.externosService.generarDocumento(vPlantillaDocumento).subscribe(
            data => {



              if (flgProcLF) {

                vListDocumentoDet[0] = new DocumentoDet();
                vListDocumentoDet[0].cdocumentoCodtipo = CodTipoFichaFUR;
                vListDocumentoDet[0].cdocumentoCodsubtipo = CodSubTipoFichaOFI;
                vListDocumentoDet[0].cdocumentoDscnombre = DscNombreFileOficioFUR;
                vListDocumentoDet[0].strDdocumentoFchreg = GetDateTime(0, 0);
                vListDocumentoDet[0].ndocumentoIdtipd = vFur.nfurId;
                vListDocumentoDet[0].fileBase64 = data.base64;



              } else {

                vGeneralReturn.dscCampo1 = data.base64;
                vGeneralReturn.flgCampo1 = true;

                observer.next(vGeneralReturn);

              }


            },
            err => {



              console.log(err);

            });

        });

    });

    return plantillaObservable;

  }

  _descargarPdf() {

    // window.open(this.strDscUrlOfi, '_blank');


    // PROVISIONAL HASTA QUE FUNCIONE EL LASERFICHE
    // console.log(Number(this.strNroRegistro));
    this._generarPlantilla(this.bodyDatosGeneralC.numFurId, false).subscribe(data => {

      console.log('============1111data');
      console.log(data);

      saveContent2(data.dscCampo1, 'Documento.pdf');

    });
    // PROVISIONAL HASTA QUE FUNCIONE EL LASERFICHE

  }

  _cambioTipRemitente() {

    this._resetDatosRemitente(1);
    this._resetDatosRemitente(2);

  }

  _resetDatosRemitente(numCaso: number) {

    switch (numCaso) {
      case 1:

        this.fur.personaOtro = new Persona();

        break;

      case 2:

        this.fur.cfurDscregotr = '';

        break;

      default:
        break;
    }


  }

  _cambioNroDoc(data: string) {

    this._resetDatosRemitente(1);

    this.fur.personaOtro.cpersonaNrodoc = data;
    this.fur.personaOtro.npersonaIdtipdoc = this._getTipoDocIdent();

    this.ValidarDatos();


  }

  _buscarServicio() {

    let vNroDoc = '';

    vNroDoc = this.fur.personaOtro.cpersonaNrodoc;

    // console.log("==========Validacin");
    // console.log(vNroDoc.length);
    // console.log(this._getMaskTipoDoc().length);

    if (vNroDoc.length != this._getMaskTipoDoc().length) {

      openModalMensaje('Remitente', 'El número de dígitos del número de documento es incorrecto, por favor verifique', this.dialog);

      return;

    }

    if (this._getFlgTipRemitPJ()) {


    } else if (this._getFlgTipRemitCiudadano()) {


    }

  }

  _getTipoDocIdent() {

    return (this._getFlgTipRemitCiudadano() ?  NumIdTipDenPersNat : (this._getFlgTipRemitPJ() ? NumIdTipDocPersJur : 1));

  }

  _getMaskTipoDoc() {

    const vIdTipDoc: number = this._getTipoDocIdent();
    const vItem = this.listTipoDocumento.find(x => x.ntipdocumentoId == vIdTipDoc);
    let vDscReturn = '';

    if (vItem != null) {

      vDscReturn = vItem.ctipdocumentoMask;

    }

    return vDscReturn;

  }

  _getDscNombreCompleto(nombres: string, apePater: string, apeMater: string) {


    return (isEmpty(apePater) ? '' : apePater) + ' '  +
           (isEmpty(apeMater) ? '' : apeMater) +
           (isEmpty(nombres) ? '' : ', ' + nombres);

  }

  _nombreCRemitente() {

    let vDscReturn = '';

    if (this._getFlgTipRemitCiudadano()) {

      vDscReturn = this._getDscNombreCompleto(this.fur.personaOtro.cpersonaNombres, this.fur.personaOtro.cpersonaApepaterno, this.fur.personaOtro.cpersonaApematerno);

      // vNombres = this.fur.personaOtro.cpersonaNombres;
      // vApePaterno = this.fur.personaOtro.cpersonaApepaterno;
      // vApeMaterno = this.fur.personaOtro.cpersonaApematerno;

      // vNombres = ", " + (isEmpty(vNombres) ? "" : vNombres);
      // vApePaterno = isEmpty(vApePaterno) ? "" : vApePaterno;
      // vApeMaterno = isEmpty(vApeMaterno) ? "" : vApeMaterno;

      // vDscReturn = vApePaterno + " "  + vApeMaterno + vNombres;

    } else {

      vDscReturn = this.fur.personaOtro.cpersonaRazonsocial;

      vDscReturn = isEmpty(vDscReturn) ? '' : vDscReturn;

    }

    return vDscReturn;

  }

  _getFlgTipRemitOtro() {

    return this.fur.nfurIdnumotr1 == NumIdCatTROtros;

  }

  _getFlgTipRemitCiudadano() {

    return this.fur.nfurIdnumotr1 == NumIdCatTRCiudadano;

  }

  _getFlgTipRemitPJ() {

    return this.fur.nfurIdnumotr1 == NumIdCatTRPJ;

  }

  _getDscValor(numCaso: number) {

    switch (numCaso) {
      case 1:

        return (this._getFlgTipRemitOtro() ? 'N° Correlativo' : 'RUC / DNI');

      case 2:

        return (this._getFlgTipRemitOtro() ? 'N° Correlativo' : 'RUC / DNI');


      default:
        break;
    }



  }

  _initVariables() {

    this.fur = new Fur();
    this.fur.personaOtro = new Persona();

    this.fur.cfurIdusureg = GlobalVars.CodPersonal;
    this.fur.nfurIdnumotr1 = NumIdCatTRCiudadano;

  }

  _nombreCReceptor() {

    const vItem: PersonalCgr = this.listPersonalCgr.find(x => x.cpPerCodigo == this.fur.cfurIdusureg);
    let vDscReturn = '';

    if (vItem != null) {

      vDscReturn = vItem.cpPerApPater + ' ' + vItem.cpPerApMater + ', ' + vItem.cpPerNombre;

    }

    return vDscReturn;

  }

  _EliminarDest(index: number) {

    this.listaExpDest.splice(index, 1);

    this.ValidarDatos();

  }

  ValidarDatos() {

    let FlgError = false;
    let flgValDatGen = false;

    // console.log("V1");

    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.fur.nfurIdnumotr1 != null ? false : true), 'Ingrese el tipo remitente', this.errorValidator, true);

    if (this._getFlgTipRemitOtro()) {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((isNotEmpty(this.fur.cfurDscregotr) ? false : true), 'Ingrese el ' + this._getDscValor(1), this.errorValidator, false);

    } else {

      this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((isNotEmpty(this.fur.personaOtro.cpersonaNrodoc) ? false : true), 'Ingrese el ' + this._getDscValor(1), this.errorValidator, false);

    }


    // console.log("V3");
    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this.fur.nfurIdtipodocexp != null ? false : true), 'Ingrese el tipo de documento', this.errorValidator, false);
    // console.log("V4");
    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((isNotEmpty(this.fur.cfurNroexpediente) ? false : true), 'Ingrese el número de documento', this.errorValidator, false);

    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((isNotEmpty(this.fur.cfurCodent) ? false : true), 'Ingrese la entidad sujeta a control', this.errorValidator, false);

    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((isNotEmpty(this.fur.cfurDschecho) ? false : true), 'Ingrese el asunto', this.errorValidator, false);

    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((isNotEmpty(this.fechaHoraMaterialC.getFechaHoraMaterialC()) ? false : true), 'Ingrese la fecha de publicación', this.errorValidator, false);

    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((isNotEmpty(this.fur.cfurDscregotr2) ? false : true), 'Ingrese le folio', this.errorValidator, false);

    // console.log("V5");
    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this._ValidaGrillaRef(this.listaExpRef)), 'Ingrese todos los datos de la lista de Referencia', this.errorValidator, false);
    // console.log("V6");
    this.errorValidator = this.mFuncErrorVal.AgregarErrorValidator((this._ValidaGrillaDest(this.listaExpDest)), 'Ingrese todos los datos de la lista de Destino', this.errorValidator, false);
    // console.log("V7");

    flgValDatGen = this.bodyDatosGeneralC.ValidarDatos();

    if (this.mFuncErrorVal.RevisarErrorValidator(this.errorValidator) || flgValDatGen) {

      FlgError = true;

    }

    return FlgError;

  }

  _setCodEntidadOut(entidadSelec: Entidad) {

    this.fur.cfurCodent = entidadSelec.centCodigo;

    this.ValidarDatos();
    // this.strCodEntidad = entidadSelec.centCodigo;

  }

  GuardarDatos() {

    const numDoc = null;
    let CodFur = null;
    let vIdFur: number = null;

    // this.fur = new Fur();

    this.fur = this.bodyDatosGeneralC.RecuperarDatos(this.fur);
    this.fur.booleanCodborrador = false;

    // numDoc = this.strNroDoc1 + "-" + this.strNroDoc2 + "-" + this.strNroDoc3;

    // this.fur.cfurCoduno = this.strCodUno;
    // this.fur.nfurIdtipodocexp = Number(this.numIdTipoDoc);
    // this.fur.cfurCodigo = numDoc;
    // this.fur.cfurNroexpediente = numDoc;
    // this.fur.cfurDschecho = this.strDscAsunto;
    this.fur.nfurIdcanal = gvCanal.NumIdExp;
     // this.fur.cfurCodtipolocal = GlobalVars.CodSNC;
    // // this.fur.cfurIdusureg = GlobalVars.CodPersonal;
    // this.fur.cfurIdususuperv = GlobalVars.CodPersSuperv;
    // this.fur.cfurCodperscgr1 = this.codPersFirmado;
    // this.fur.cfurCodperscgr2 = this.codPersElaborado;


    this.fur.cfurIdususuperv = GlobalVars.CodPersSuperv;

    this.fur.strDfurFchrecep = GetDateTimeString(this.fechaHoraMaterialC.getFechaHoraMaterialC());
    // CFUR_CODPERSCGR1

    this.fur.listaExpedienteDet = [];

    this.listaExpRef.forEach(element => {

      // 2020-01-23

      element.strDexpdetFecha = ConvertStrDateToFormatBD(element.strDexpdetFecha); // element.fch_registro;

      // Provisional por que no se tiene el servicio del combo
      element.nexpdetIdtipdoc = Number(element.nexpdetIdtipdoc);
      element.nexpdetIdprioridad = Number(element.nexpdetIdprioridad);


      this.fur.listaExpedienteDet.push(element);

    });

    this.listaExpDest.forEach(element => {

      // element.strDexpdetFecha = element.fch_registro;
       // Provisional por que no se tiene el servicio del combo
       // element.nexpdetIdtipodoc = Number(element.nexpdetIdtipodoc);
       element.nexpdetIdprioridad = Number(element.nexpdetIdprioridad);

       this.fur.listaExpedienteDet.push(element);

    });




    // for (let index = 0; index < array.length; index++) {

    //   const element = array[index];

    // }

    // this.fur.listaExpedienteDet =

    return new Observable((observer) => {

      console.log('==================this.fur');

      console.log(JSON.stringify(this.fur) );

      if (!this.flgRegistrar) {

        console.log('==================ACTUALIZAR');



        this.furService.ActualizarFur(this.fur).subscribe(data => {

          CodFur = data.cfurCodigo;
          vIdFur = data.nfurId;

          if (isNotEmpty(CodFur)) {

            this._postTransaccion(CodFur, vIdFur);

          } else {

            openModalMensaje('Expediente', 'Ocurrió un problema en la actualización del registro', this.dialog).afterClosed().subscribe(result => {

              // observer.error();

              observer.complete();

              // return flgProcesado;

            });

            // flgGuardado = false;

            return;

          }

          // this.opGuardado.emit(flgGuardado);

          // return

        },
        err => {

          console.log(err);


        });

      } else {

        console.log('==================REGISTRAR');

        this.furService.RegistrarFur(this.fur).subscribe(data => {

          CodFur = data.cfurCodigo;
          vIdFur = data.nfurId;

          if (isNotEmpty(CodFur)) {

            this._postTransaccion(CodFur, vIdFur);


          } else {

            openModalMensaje('Expediente', 'Ocurrió un problema en la actualización del registro', this.dialog).afterClosed().subscribe(result => {

              // observer.error();

              observer.complete();

              // return flgProcesado;

            });

            // flgGuardado = false;

            // return;

          }

          // this.opGuardado.emit(flgGuardado);

          // return

        },
        err => {

          console.log(err);


        });

      }

      // var flgProcesado = false;

      return () => {

      };
    });

  }

  _getNroExpediente() {

    const numReturn: number  = (this.bodyDatosGeneralC ? this.bodyDatosGeneralC.numFurId : null);

    return numReturn;

  }

  _postTransaccion(codFur: string, idFur: number) {



  }

  SetDatosExpedienteC(data: Fur) {

    const listaExpediente = data.listaExpedienteDet;

    this.fur = data;

    data.listaExpedienteDet.forEach(element => {

      element.strDexpdetFecha = ConvertDateTimeToStr(element.dexpdetFecha);

    });


    if (listaExpediente != null) {

      this.listaExpRef = FiltrarListExpedienteRef(data.listaExpedienteDet); // data.listaExpedienteDet.filter(x=>x.cexpdetCodtipo == CodTipoExpDetREF);
      this.listaExpDest = FiltrarListExpedienteDest(data.listaExpedienteDet); // data.listaExpedienteDet.filter(x=>x.cexpdetCodtipo == CodTipoExpDetDES);

    }

    // this.bodyDatosGeneralC.strIdExpediente = data.nfurId.toString();
    this.bodyDatosGeneralC.strIdExpediente = data.cfurCodigo;
    this.bodyDatosGeneralC.strFechaRegistro = RecupPartesFchInicio(data.strDfurFecinicioreg, 2);
    this.bodyDatosGeneralC.strHoraReg = RecupPartesFchInicio(data.strDfurFecinicioreg, 1);
    this.bodyDatosGeneralC.numCantTiempo = data.nfurNumplazo;
    this.bodyDatosGeneralC.numIdPlazo = data.nfurIdplazo;
    this.bodyDatosGeneralC.numFurId = data.nfurId;

    this.evidenciasC.setEvidenciaC(data);

    this.fechaHoraMaterialC.setFechaHoraMaterialC(ConvertDateTimeToStr2(data.dfurFchrecep));

    this.busqEntidadComponent.setEntidad(this.fur.cfurCodent, false);
    this.flgRegistrar = false;

    this.strDscUrlOfi = RecupUrlOficio(data.listaDocumentoAdjuntoDet);

  }

//   _GuardarDatos(observer)
//   {

// //    return new Observable()

//     var numDoc = null;
//     var idFur = null;
//     //var flgGuardado = true;

//     this.fur = new Fur();

//     // if(this.ValidarDatos() || this.bodyDatosGeneralC.ValidarDatos())
//     // {

//     //   observer.error();

//     //   return;
//     // }

//     // setTimeout(() => {

//     //   this.fur = this.bodyDatosGeneralC.RecuperarDatos(this.fur);

//     // }, 1);

//     console.log(this.bodyDatosGeneralC);

//     this.bodyDatosGeneralC.RecuperarDatos(this.fur).subscribe((data:Fur)=>{

//       //this.fur = data;

//       this.fur = data;

//     });


//     numDoc = this.strNroDoc1 + "-" + this.strNroDoc2 + "-" + this.strNroDoc3;

//     this.fur.cfurCoduno = this.strCodUno;
//     this.fur.nfurIdtipodocexp = this.numIdTipoDoc;
//     //this.fur.cfurCodigo = numDoc;
//     this.fur.cfurNroexpediente = numDoc;
//     this.fur.cfurDschecho = this.strDscAsunto;

//     this.furService.ActualizarFur(this.fur).subscribe(data=>{

//       idFur = data.nfurId;

//       if(idFur > 0)
//       {

//         openModalMensaje("Expediente",`Se generó el Expediente Nro. ${idFur}, por favor verifique`,this.dialog).afterClosed().subscribe(result=>{

//           this.bodyDatosGeneralC.strIdExpediente = idFur;
//           observer.complete();

//         });

//       }else{

//         openModalMensaje("Expediente","Ocurrió un problema en la actualización del registro",this.dialog).afterClosed().subscribe(result=>{

//           observer.error();

//         });

//         //flgGuardado = false;

//         return;

//       }

//       //this.opGuardado.emit(flgGuardado);

//       //return

//     });

//   }

  _ValidaGrillaRef(listaExpedienteDet: ExpedienteDet[]) {

    let FlgError = false;

    if (listaExpedienteDet.filter(x => x.cexpdetCodanho == null ||
      x.nexpdetIdtipdoc == null ||
      x.cexpdetNrodoc == null ||
      x.cexpdetNroexp == null ||
      x.strDexpdetFecha == null
      // ||
      // x.cexpdetDscindica == null ||
      // x.nexpdetIdprioridad == null
      ).length > 0 || listaExpedienteDet.length == 0) {

      FlgError = true;

    }

    return FlgError;

  }

  _ValidaGrillaDest(listaExpedienteDet: ExpedienteDet[]) {

    let FlgError = false;

    if (listaExpedienteDet.filter(x => x.cexpdetCoduno == null ||
      x.cexpdetCodlocal == null ||
      x.cexpdetCodpersonal == null ||
      x.cexpdetCodresp == null ||
      x.cexpdetDscindica == null ||
      x.nexpdetIdprioridad == null
      ).length > 0 || listaExpedienteDet.length == 0) {

      FlgError = true;

    }

    return FlgError;

  }

  _AgregarRef() {

    const numUltReg = this.listaExpRef.length;

    this.listaExpRef[numUltReg] = new ExpedienteDet();
    this.listaExpRef[numUltReg].cexpdetCodtipo = CodTipoExpDetREF;
    this.listaExpRef[numUltReg].cexpdetCodanho = null;
    this.listaExpRef[numUltReg].nexpdetIdtipdoc = null;
    this.listaExpRef[numUltReg].cexpdetNrodoc = null;
    this.listaExpRef[numUltReg].cexpdetNroexp = null;
    this.listaExpRef[numUltReg].strDexpdetFecha = null;
    this.listaExpRef[numUltReg].cexpdetDscindica = null;
    this.listaExpRef[numUltReg].nexpdetIdprioridad = null;

  }

  _EliminarRef(index: number) {

    this.listaExpRef.splice(index, 1);

    this.ValidarDatos();

  }

  _AgregarDest() {

    const numUltReg = this.listaExpDest.length;

    this.listaExpDest[numUltReg] = new ExpedienteDet();
    this.listaExpDest[numUltReg].cexpdetCodtipo = CodTipoExpDetDES;
    this.listaExpDest[numUltReg].cexpdetCoduno = null;
    this.listaExpDest[numUltReg].cexpdetCodlocal = null;
    this.listaExpDest[numUltReg].cexpdetCodpersonal = null;
    this.listaExpDest[numUltReg].cexpdetCodresp = null;
    this.listaExpDest[numUltReg].cexpdetDscindica = null;
    this.listaExpDest[numUltReg].nexpdetIdprioridad = null;

  }

  soloLectura(flgParam: boolean) {
    this.bodyDatosGeneralC.flgSoloLectura = flgParam;
    this.flgSoloLectura = flgParam;
    this.busqEntidadComponent.setModoLectura(flgParam);
    this.fechaHoraMaterialC.setSoloLectura(flgParam);
    this.evidenciasC.setSoloLectura(flgParam);
  }

}
